var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#DCF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.35V15.65C18 16.008 17.8663 16.3514 17.6283 16.6046C17.3902 16.8578 17.0674 17 16.7308 17H8.26923C7.93261 17 7.60978 16.8578 7.37175 16.6046C7.13372 16.3514 7 16.008 7 15.65V9.35M18 9.35C18 8.99196 17.8663 8.64858 17.6283 8.39541C17.3902 8.14223 17.0674 8 16.7308 8H8.26923C7.93261 8 7.60978 8.14223 7.37175 8.39541C7.13372 8.64858 7 8.99196 7 9.35M18 9.35V9.4958C18 9.72629 17.9446 9.95294 17.8389 10.1542C17.7333 10.3554 17.5809 10.5245 17.3964 10.6454L13.1656 13.4144C12.9655 13.5455 12.7351 13.615 12.5 13.615C12.2649 13.615 12.0345 13.5455 11.8344 13.4144L7.60359 10.646C7.41908 10.5251 7.26675 10.356 7.16109 10.1548C7.05543 9.95354 6.99998 9.72689 7 9.4964V9.35",
    stroke: "#001F3B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCMail);
export default __webpack_public_path__ + "static/media/c-mail.14d1dc2b15d5cf63759ad0eeb8ef5883.svg";
export { ForwardRef as ReactComponent };